<template>
  <div
    :class="{
      iframePup: true,
      popupClass_green: styleType == 'typeGreen' ? true : false,
      popupClass_blue: styleType == 'typeBlue' ? true : false,
      popupClass_dark: styleType == 'typeDark' ? true : false,
      popupClass_strong: styleType == 'typeStrong' ? true : false,
    }"
  >
    <div class="closeBox" v-if="styleType == 'typeDark'" @click="close()"></div>
    <div
      class="closeBox_green"
      v-else-if="styleType == 'typeGreen'"
      @click="close()"
    ></div>
    <div
      class="closeBox_blue"
      v-else-if="styleType == 'typeBlue'"
      @click="close()"
    ></div>
    <div
      class="closeBox_blue"
      v-else-if="styleType == 'typeStrong'"
      @click="close()"
    ></div>
    <img
      v-if="
        videoUrl.toLowerCase().indexOf('jpg') != -1 ||
        videoUrl.toLowerCase().indexOf('png') != -1
      "
      :src="videoUrl"
    />
    <video v-else class="videoBar" :src="videoUrl" loop muted controls />
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  name: "iframe-pup",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["videoUrl"],
  data() {
    //这里存放数据
    return {
      styleType: "",
    };
  },
  //计算属性 类似于data概念
  computed: {
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
  },
  //监控data中的数据变化
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
      },
      deep: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.styleType = this.$store.state.styleType;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  //方法集合
  methods: {
    close() {
      let that = this._.appContext.app;
      if (!this.type) {
        this.$popup.close(that);
      } else {
        this.$popup.close2(that);
      }
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped='scoped'>
.popupClass_green {
  background: rgb(14, 82, 76);
}
.popupClass_dark {
  background: rgb(0, 0, 0);
}
.popupClass_blue {
  background: rgb(8,25,57);
}
.popupClass_strong {
  background: radial-gradient(rgb(26 88 169), rgb(1 19 41 / 70%));
}
.iframePup {
  width: 1734px;
  height: 950px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  iframe {
    width: 100%;
    height: 100%;
  }
  img {
    position: relative;
    width: calc(100% - 40px);
    height: calc(100% - 60px);
    margin: 50px 20px 10px 20px;
  }
  .videoBar {
    position: relative;
    width: 80%;
    height: 80%;
    margin: 5% 10%;
  }
  .closeBox {
    position: absolute;
    top: 0px;
    right: 4px;
    width: 122px;
    height: 38px;
    background-image: url("../img/close.png");
    background-size: 100% 100%;
    cursor: pointer;
    z-index: 1;
    &:hover {
      background-image: url("../img/close_active.png");
    }
  }
  .closeBox_green {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 60px;
    height: 36px;
    background-image: url("../img/close_green.png");
    background-size: 100% 100%;
    cursor: pointer;
    z-index: 1;
    &:hover {
      background-image: url("../img/close_green_active.png");
    }
  }
  .closeBox_blue {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 60px;
    height: 60px;
    background-image: url("/static/img/popupImg/close_default_blue.png");
    background-size: 100% 100%;
    cursor: pointer;
    z-index: 1;
    &:hover {
      background-image: url("/static/img/popupImg/close_blue.png");
    }
  }
}
</style>